import { render, staticRenderFns } from "./UpdateDefectDialog.vue?vue&type=template&id=73a5a2ba&scoped=true&"
import script from "./UpdateDefectDialog.vue?vue&type=script&lang=js&"
export * from "./UpdateDefectDialog.vue?vue&type=script&lang=js&"
import style0 from "./UpdateDefectDialog.vue?vue&type=style&index=0&id=73a5a2ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a5a2ba",
  null
  
)

export default component.exports